import React, { useEffect, useRef, useState } from "react";
import styles from "./EditProfile.module.css";
import {
  InputField,
  Modal,
  PhoneInput,
  TextComponent,
} from "../../../../components";
import imagePlaceHolder from "../../../../assets/images/dummy.png";
import { PiSealCheck } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
const EditProfile = ({
  editProfileModal,
  setEditProfileModal,
  details,
  setDetails,
  ProfileDetails,
}) => {
  const [firstName, setFirstName] = useState(
    ProfileDetails?.first_name ? ProfileDetails?.first_name : "",
  );
  const [lastName, setLastName] = useState(
    (ProfileDetails?.type === "customer" || !ProfileDetails?.is_owner) &&
      ProfileDetails?.last_name
      ? ProfileDetails?.last_name
      : ProfileDetails?.full_name
        ? ProfileDetails?.full_name
        : "",
  );
  const [contactNo, setContactNo] = useState(
    ProfileDetails?.contact_no ? ProfileDetails?.contact_no : "",
  );
  const [email, setEmail] = useState(
    ProfileDetails?.email ? ProfileDetails?.email : "",
  );
  const [address, setAddress] = useState(
    ProfileDetails?.address ? ProfileDetails?.address : "",
  );
  // const [dealerId, setDealerId] = useState(
  //   ProfileDetails?.dealer_id ? ProfileDetails?.dealer_id : "",
  // );
  const [profileImage, setProfileImage] = useState(null);
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [is_customer, setIs_customer] = useState(false);

  const hiddenFileInput = useRef();
  const dispatch = useDispatch();

  const handleFileHandler = () => {
    hiddenFileInput.current.click();
  };

  const updateProfile = () => {
    // if (is_customer && (!firstName || !lastName)) {
    //   dispatch(
    //     showAlert({
    //       title: "First Name",
    //       message: "Please your Full Name",
    //       type: "Error",
    //       status: "400",
    //     }),
    //   );
    // }
    if (!contactNo) {
      dispatch(
        showAlert({
          title: "Contact No",
          message: "Please enter valid Contact No",
          type: "Error",
          status: "400",
        }),
      );
    }

    if (!email) {
      dispatch(
        showAlert({
          title: "email",
          message: "Please enter valid Email",
          type: "Error",
          status: "400",
        }),
      );
    }
    if (!address) {
      dispatch(
        showAlert({
          title: "address",
          message: "Please enter address",
          type: "Error",
          status: "400",
        }),
      );
    }
    // if (!dealerId) {
    //   dispatch(
    //     showAlert({
    //       title: "dealerId",
    //       message: "Please enter dealer ID",
    //       type: "Error",
    //       status: "400",
    //     }),
    //   );
    // }
    // if (!profileImage) {
    //   dispatch(
    //     showAlert({
    //       title: "Image",
    //       message: "Please upload Profile Image",
    //       type: "Error",
    //       status: "400",
    //     })
    //   );
    // }

    let userData = {
      first_name: firstName,
      last_name: lastName,
      name: lastName,
      email: email,
      address: address,
      contact_no: contactNo,
      profile_picture: profileImage ? profileImage : null,
      // dealer_id: dealerId,
    };
    if (is_customer) {
      delete userData.name;
    } else {
      delete userData.first_name;
      delete userData.last_name;
    }
    dispatch(AuthMiddleware.updateProfile(userData))
      .then(() => {
        setEditProfileModal(false);
        setIsSuccessFulModal(true);
        dispatch(AuthMiddleware.getUserData());
      })
      .catch(() => {});
  };

  useEffect(() => {
    setIs_customer(
      ProfileDetails?.type === "customer" || !ProfileDetails?.is_owner
        ? true
        : false,
    );
  }, [ProfileDetails?.type]);

  return (
    <div className={styles.mainCont}>
      <Modal
        width={"600px"}
        open={editProfileModal}
        onCancel={() => {
          setEditProfileModal(false);
          setDetails([]);
        }}
        twoButton
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setEditProfileModal(false);
          setDetails([]);
        }}
        okBtnTitle={"Save Information"}
        onClickOkButton={updateProfile}
      >
        <div className={styles.edit_mainCont}>
          <div className={styles.edit_heading}>
            <TextComponent
              text={"Edit Profile"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--heading2-font-size)",
              }}
            />
            <TextComponent
              text={"Update profile information"}
              style={{ color: "var(--light-grey)" }}
            />
          </div>
          <div className={styles.profileImg}>
            <img
              src={
                profileImage
                  ? URL.createObjectURL(profileImage)
                  : ProfileDetails?.profile_picture
                    ? ProfileDetails?.profile_picture
                    : imagePlaceHolder
              }
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImage(e.target.files[0])}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            />
            <div className={styles.opacityCont}></div>
            <div className={styles.changeImageDiv}>
              <TextComponent
                text={"Change"}
                className={
                  profileImage ? styles.changeText : styles.changeTextUpload
                }
                onClick={handleFileHandler}
              />
              <div
                className={styles.deleteCont}
                style={{ display: !profileImage && "none" }}
                onClick={() => setProfileImage()}
              >
                <RiDeleteBin6Line size={18} color={"var(--primary-color)"} />
              </div>
            </div>
          </div>
          {is_customer ? (
            <div className={styles.twoInputsDivs}>
              <InputField
                className={styles.twoInputs}
                label={"First name"}
                placeholder={"Chris"}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <InputField
                className={styles.twoInputs}
                label={"Last name"}
                placeholder={"Glasser"}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          ) : (
            <InputField
              className={styles.input}
              label={"Full Name"}
              placeholder={"Chris lastname"}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          )}
          <InputField
            label={"Email"}
            placeholder={"chris@email.com"}
            value={email}
            disabled={true}
            // onChange={(e) => setEmail(e.target.value)}
          />
          {/* <InputField
            label={"Dealer ID"}
            placeholder={"dealer_123"}
            value={dealerId}
            onChange={(e) => setDealerId(e.target.value)}
          /> */}
          <PhoneInput
            label={"Contact number"}
            placeholder={"(301) 580-7410"}
            value={contactNo}
            onChange={setContactNo}
          />
          <InputField
            label={"Address"}
            placeholder={"4387 Farland Avenue, San Antonio, TX 78212"}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </div>
  );
};

export default EditProfile;
